/* eslint-disable max-len */
import React from 'react'
import type { HTMLElementProps } from '~/types'
import { cn } from '~/utils'
type Props = HTMLElementProps<'svg'>

export const CartIcon: React.FC<Props> = ({
	stroke = 'currentColor',
	fill = 'none',
	height = '26px',
	className,
	...props
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
		fill="none"
		className={cn('align-middle', className)}
		height={height}
		stroke={stroke}
		strokeWidth={1}
		strokeLinecap="round"
		strokeLinejoin="round"
		strokeMiterlimit="10"
		viewBox="0 0 22 16"
		{...props}
	>
		<mask id="cart-mask">
			<rect width={22} height={16} fill="white" />
			<circle cx={9.02} cy={13.88} r={1.63} fill="black" />
			<circle cx={17.74} cy={13.88} r={1.63} fill="black" />
		</mask>
		<path d="m6.97 11.03-.81 1.07a.68.68 0 0 0 .46 1.09h11.95M.89.86H3.1l1.03 2.1" mask="url(#cart-mask)" />
		<path fill={fill} d="M21.3 2.97H4.14l2.94 8.06h11.28l2.94-8.06Z" />
		<circle cx={9.02} cy={13.88} r={1.63} fill={fill} stroke="#3faf6d" />
		<circle cx={17.74} cy={13.88} r={1.63} fill={fill} stroke="#3faf6d" />
	</svg>
)
